import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';

import DefaultFallback from '_boundaries/DefaultFallback/DefaultFallback';
import Login from 'Login/Login';
import Logo from '_components/Logo/Logo';
import PageLoadingSpinner from '_components/PageLoadingSpinner/PageLoadingSpinner';
import SessionInitializer from 'Login/SessionInitializer';
import Welcome from 'Welcome/Welcome';

// Lazy load major components to improve performance.
// These will be loaded only when their corresponding routes are accessed.
const Debrief = React.lazy(() => import('Debrief/Debrief'));
const Overview = React.lazy(() => import('Overview/Overview'));
const QualityControl = React.lazy(() => import('QualityControl/QualityControl'));
const Survey = React.lazy(() => import('Survey/Survey'));

import 'bootstrap/dist/css/bootstrap.min.css';

const App = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary FallbackComponent={DefaultFallback}>
        <SessionInitializer />
        <React.Suspense fallback={<PageLoadingSpinner label="Loading page content" />}>
          <Logo />
          <Routes>
            <Route path='/' element={<Login/>} />
            <Route path='login' element={<Login/>} />
            <Route path='login/:login_code_value' element={<Login/>} />
            <Route path='welcome' element={<Welcome/>} />
            <Route path='overview' element={<Overview/>} />
            <Route path='surveys/:slug' element={<Survey />} />
            <Route path='quality-control' element={<QualityControl />}/>
            <Route path='debrief' element={<Debrief />}/>
          </Routes>
        </React.Suspense>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default App;